/**
 * Theme bootstrap: responsive image sizing, keycodes, touch class.
 * Loaded at end of body; lazy-image snippets register on DOMContentLoaded.
 */
const rbi = [];

const ribSetSize = (img) => {
  if (!img || !img.dataset.ratio) return;
  if (img.offsetWidth / img.dataset.ratio < img.offsetHeight) {
    img.setAttribute('sizes', `${Math.ceil(img.offsetHeight * img.dataset.ratio)}px`);
  } else {
    img.setAttribute('sizes', `${Math.ceil(img.offsetWidth)}px`);
  }
};

const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

window.rbi = rbi;
window.ribSetSize = ribSetSize;

window.KEYCODES = {
  TAB: 9,
  ESC: 27,
  DOWN: 40,
  RIGHT: 39,
  UP: 38,
  LEFT: 37,
  RETURN: 13,
};

window.addEventListener(
  'resize',
  debounce(() => {
    for (const img of rbi) {
      ribSetSize(img);
    }
  }, 250)
);

if (
  'ontouchstart' in window ||
  (window.DocumentTouch && document instanceof DocumentTouch)
) {
  document.body.classList.remove('no-touchevents');
  document.body.classList.add('touchevents');
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-responsive-background-id]').forEach((el) => {
    const imgId = el.getAttribute('data-responsive-background-id');
    const img = document.getElementById(imgId);
    if (!img) return;
    rbi.push(img);
    ribSetSize(img);
  });
});
